module.exports = __webpack_public_path__ + "img/tarjeta3.3114e2c1.png";